import React from 'react';
import { useMachineStatusHook } from './hooks/useMachineStatus';
import { LoadingContainer, MachineStatusContainer } from './MachineStatus.elements';
import { useMachineInfo } from 'common/pages/fleetV2/providers';
import { MachineStatusProps } from './types';



export const MacineStatus = (): JSX.Element => {

    const { businessUnit } = useMachineInfo();

    const hook = useMachineStatusHook(businessUnit);
    const  { 
      color,
      status,
      Icon,
      timestamp,
      isLoading, 
      hasError
     } = hook() as MachineStatusProps;
    
    if(hasError)return <></>
    if(isLoading) return <LoadingContainer></LoadingContainer>

    return (
      <div className="machine-info-bar__item machine-status">
        <MachineStatusContainer className="machine-status-icon" {...{ color }}>
          <span className="label">{status}</span> {Icon} {timestamp && <span className="timestamp">{timestamp}</span>}
        </MachineStatusContainer>
      </div>
    );
  };
  